<script>

import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components: {

  },
  props: {
    caixasList: {
      type: Array,
      default: function () {
        return [];
      },
    }
  },
  validations: {
    regSelecionado :{
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      status: {
        required: helpers.withMessage("Campo status obrigatório, favor preencher.", required),
      },

    }
  },
  mounted() {
    // console.log('mounted table_0')
    // console.log(this.updating)
  },
  methods: {

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    nomeStatusTipo(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'EN':
          result = 'Entrada'
          break
        case 'SA':
          result = 'Saída'
          break
      }
      return result
    },

    editar(dataID){
      console.log('editar: ' + dataID)
      // this.showModal = true
      // this.regSelecionado = this.caixasList.find((reg) => reg.id === dataID);
      // console.log('regSelecionado: ')
      // console.log(this.regSelecionado)
      this.$router.push(`/caixa/editar/${dataID}`)

    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', dataID)
        }
      })
    },

    formSubmit() {
      console.log('formSubmit_0')
      this.submitted = true
      this.v$.$touch()
      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.$emit('alterareg', this.regSelecionado)
      }
      this.submitted = false
    },

    setCriarNova: function() {
      this.regSelecionado = {}
      this.showModal = true;
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },
    formatDecimalCub(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
      }
      return 0.00;
    },

    formatDateTime(value) {
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  data() {
    return {
      regSelecionado: {},
      submitted: false,
      showModal: false,
    };
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap">
      <thead class="table-light">
      <tr>

        <th class="text-center">ID</th>
        <th class="text-center">Código</th>
        <th class="text-center">Descrição</th>
        <th class="text-center">Status</th>
        <th class="">Altura (cm)</th>
        <th class="">Largura (cm)</th>
        <th class="">Comprimento (cm)</th>
        <th class="">Cubagem (m³)</th>
        <th class="">Peso (Kg)</th>
        <th class="">Criação</th>
        <th class="text-center">Ações</th>
      </tr>
      </thead>
      <tbody v-if="caixasList">
      <tr v-for="data in caixasList" :key="data.id">
        <td class="text-center">
          <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">{{
              data.id
            }}</a>
        </td>
        <td class="text-center">{{ data.codigo }} </td>
        <td class="text-center">{{ data.descricao }} </td>
        <td class="text-center">
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                {{ nomeStatus(data.status)  }}
              </span>
        </td>
        <td>{{ formatDecimal(data.altura) }} </td>
        <td>{{ formatDecimal(data.largura) }} </td>
        <td>{{ formatDecimal(data.comprimento) }} </td>
        <td>{{ formatDecimalCub(data.cubagem) }} </td>
        <td>{{ formatDecimal(data.peso) }} </td>
        <td>{{ formatDateTime(data.created_at) }} </td>
        <td class="text-center">
          <div class="button-items">
            <b-button variant="outline-success" @click="editar(data.id)">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>
            <b-button variant="outline-danger" @click="deletar(data.id)">
              <i class="mdi mdi-trash-can d-block font-size-16"></i>
            </b-button>
          </div>
        </td>

      </tr>
      </tbody>
    </table>


  </div>

</template>
